export const CREATE_CHAT_SESSION_MUTATION = `
  mutation CreateChatSession($input: CreateChatSessionInput) {
    createChatSession(input: $input) {
      chatSessionId
      chatUrl
      expiresAt
      ttlSeconds
    }
  }
`;
